import { render, staticRenderFns } from "./app-detail-download-rc-pannel.vue?vue&type=template&id=241722ea&scoped=true&"
import script from "./app-detail-download-rc-pannel.vue?vue&type=script&lang=js&"
export * from "./app-detail-download-rc-pannel.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-download-rc-pannel.vue?vue&type=style&index=0&id=241722ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241722ea",
  null
  
)

export default component.exports